const EMAIL_CONTACT = process.env.REACT_APP_EMAIL_CONTACT

export { EMAIL_CONTACT }
